// packages/ui-lib/src/components/Text.css.ts
var align = { left: "Text_left__82cy5oe", right: "Text_right__82cy5of", center: "Text_center__82cy5og" };
var textColor = { "default": "Text_default__82cy5oh", subtle: "Text_subtle__82cy5oi", subtleDanger: "Text_subtleDanger__82cy5oj" };
var textSize = { inherit: "Text_inherit__82cy5o1", touchable: "Text_touchable__82cy5o2", "min-touchable": "Text_min-touchable__82cy5o3", xs: "Text_xs__82cy5o4", small: "Text_small__82cy5o5", base: "Text_base__82cy5o6", large: "Text_large__82cy5o7", xl: "Text_xl__82cy5o8" };
var truncate = "Text__82cy5od";
var weight = { regular: "Text_regular__82cy5o9", medium: "Text_medium__82cy5oa", semibold: "Text_semibold__82cy5ob", strong: "Text_strong__82cy5oc" };

export {
  align,
  textColor,
  textSize,
  truncate,
  weight
};
//# sourceMappingURL=chunk-IY7VD4JL.js.map
